import { Title } from './styles'

export function Heading({ title }: { title: string }) {
  return <Title as="h2">{title}</Title>
}
